import { render, staticRenderFns } from "./SportsScores.vue?vue&type=template&id=bb88e5d0&scoped=true&"
import script from "./SportsScores.vue?vue&type=script&lang=js&"
export * from "./SportsScores.vue?vue&type=script&lang=js&"
import style0 from "./SportsScores.vue?vue&type=style&index=0&id=bb88e5d0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb88e5d0",
  null
  
)

export default component.exports